import { Vector4 } from "three";
import Base from "../../../../models/Base";
import {
  normTexture,
  complementTexture,
  colorMap,
  complementColorMap,
} from "../../constants/bases";
import {
  getBaseRectMesh,
  getLettersMesh,
  drawBaseRect,
  drawBaseLetter,
} from "./dnaBlueprint";

function getDefaultState() {
  return { bases: [] };
}

function baseTrackController(track) {
  const rectMesh = getBaseRectMesh();
  const letterMesh = getLettersMesh();
  let state = getDefaultState();

  function onReset() {
    state = getDefaultState();
  }

  function getOverlayProps({ r1, r2, domainDist }) {
    const dist = Math.ceil(domainDist);
    return { r1, r2, dist };
  }

  function onRangeChange(props) {
    const { rangeDist, chrSegments, domainDist } = props;
    const baseWidth = rangeDist / domainDist;
    const isLettersVis = baseWidth > 15;
    const isRectsVis = baseWidth > 1;
    const overlayProps = isRectsVis ? null : getOverlayProps(props);

    letterMesh.setIsVisible(isLettersVis);

    track.loadPosition(chrSegments);
    track.setOverlayProps(overlayProps);
  }

  function onDataReceived({ chr, res, x0 }) {
    const bArr = typeof res === "string" ? res.split("") : [];
    const bases = bArr.map((code, i) => new Base(code, i + x0, chr));
    state.bases = state.bases.concat(bases);
    rectMesh.setItems(state.bases);
    letterMesh.setItems(state.bases);

    drawBaseRect(bases, rectMesh);
    drawBaseLetter(bases, letterMesh);

    track.requestRender();
  }

  function onStrandInverted() {
    const isInverted = track.getStrandInverted();
    const black = new Vector4(0, 0, 0, 1);
    const white = new Vector4(1, 1, 1, 1);
    const texture = isInverted ? complementTexture : normTexture;
    const textCol = isInverted ? black : white;
    const colors = isInverted ? complementColorMap : colorMap;
    letterMesh.uniforms.setColorMap([textCol]);
    rectMesh.uniforms.setColorMap(colors);
    letterMesh.uniforms.setTexture(texture);
    track.requestRender();
  }

  return {
    onReset,
    onStrandInverted,
    onRangeChange,
    onDataReceived,
    meshes: [rectMesh, letterMesh],
  };
}

export default baseTrackController;
